const lbaLoader = angular.module('app.lbaLoader', []);

lbaLoader.controller('lbaLoaderCtrl', require('./lbaLoaderCtrl'));
lbaLoader.directive('lbaLoader', require('./lbaLoaderDir'));

export default lbaLoader;



// WEBPACK FOOTER //
// ./src/components/lbaLoader/index.js